<template>
    <v-layout justify-center>
        <v-responsive max-width="1980px" width="100%" class="px-0 px-md-4 px-xl-8">
            <v-row class="mt-0 mt-md-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">반품관리</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="py-0">
                        <v-row class="mt-4" align="center">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-date-field v-model="filter.startDate" label="주문일자" placeholder=" " dense hide-details @input="filter.createDate[0] = filter.startDate ? new Date(`${filter.startDate} 00:00:00.000`).getTime() : null"></v-date-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-date-field v-model="filter.endDate" label="주문일자" placeholder=" " dense hide-details @input="filter.createDate[1] = filter.endDate ? new Date(`${filter.endDate} 23:59:59.999`).getTime() : null"></v-date-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-6">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" dense hide-details label="상세조건" placeholder=" "></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="filter.searchValue" dense hide-details :disabled="!filter.searchKey"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="search"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-row class="mt-4">
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"><v-icon class="mr-2">mdi-truck-check-outline</v-icon>반품요청</v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="auto" class="py-0 pl-0"><span class="font-weight-bold"><button class="primary--text" @click="filter.claimStatus='return-request'; filter.collectStatus=null; search();">{{ dashboard.returnRequest.format() }}</button></span>건</v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"><v-icon class="mr-2">mdi-package-variant</v-icon>반품수거중</v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="auto" class="py-0 pl-0"><span class="font-weight-bold"><button class="primary--text" @click="filter.claimStatus='return-request'; filter.collectStatus='collect-progress'; search();">{{ dashboard.collectProgress }}</button></span>건</v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"><v-icon class="mr-2">mdi-package-variant</v-icon>반품수거완료</v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="auto" class="py-0 pl-0"><span class="font-weight-bold"><button class="primary--text" @click="filter.claimStatus=['return-request','return-complete']; filter.collectStatus='collect-complete'; search();">{{ dashboard.collectComplete }}</button></span>건</v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"><v-icon class="mr-2">mdi-clipboard-check-outline</v-icon>반품완료</v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="auto" class="py-0 pl-0"><span class="font-weight-bold"><button class="primary--text" @click="filter.claimStatus='return-complete'; filter.collectStatus=null; search();">{{ dashboard.returnComplete }}</button></span>건</v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-data-table v-model="selected" :headers="purchasesHeaders" :items="purchases" show-select disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
                <template v-slot:item.createDate="{ item }">
                    {{ item.createDate.toDateTime() }}
                </template>
                <template v-slot:item.order.sender="{ item }">
                    <div :class="{ 'red--text': item.user ? item.user.warning : false }">{{ item.order.sender.name }}</div>
                    <div :class="{ 'red--text': item.user ? item.user.warning : false }">{{ item.order.sender.phone }}</div>
                    <div :class="{ 'red--text': item.user ? item.user.warning : false }">{{ item.order.sender.email }}</div>
                </template>
                <template v-slot:item.order.receiver="{ item }">
                    <div>{{ item.order.receiver.name }}</div>
                    <div>{{ item.order.receiver.phone }}</div>
                    <div>{{ item.order.receiver.email }}</div>
                </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="search"></v-pagination>

            <v-card class="mt-4">
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" md="2" class="py-0">반품처리</v-col>
                        <v-col cols="12" sm="9" md="10" class="py-0">
                            <v-btn color="primary" outlined class="mr-2" small @click="collectComplete">수거 완료처리</v-btn>
                            <v-btn color="primary" outlined class="mr-2" small @click="returnComplete">반품 완료처리</v-btn>
                            <v-btn color="primary" outlined class="mr-2" small @click="claimReplyDialog = true">반품 거부처리</v-btn>
                            <v-btn color="primary" outlined class="mr-2" small @click="exchangeRequest">교환으로 변경</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row align="center">
                        <v-col cols="12" sm="3" md="2" class="py-0">정보 수정</v-col>
                        <v-col cols="12" sm="9" md="10" class="py-0">
                            <!-- <v-btn color="primary" outlined class="mr-2" small @click="claimReplyDialog = true">반품사유 수정</v-btn> -->
                            <v-btn color="primary" outlined class="mr-2" small @click="collectDialog = true">수거정보 수정</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-dialog v-model="claimReplyDialog" max-width="500px">
                <v-card>
                    <v-card-title class="subtitle-1">반품 거부처리</v-card-title>
                    <v-card-text>
                        <v-textarea v-model="claimReply" label="반품거부사유" placeholder=" "></v-textarea>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="claimReplyDialog = false">취소</v-btn>
                        <v-btn color="primary" text @click="returnReject">저장</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="collectDialog" max-width="500px">
                <v-card>
                    <v-card-title class="subtitle-1">수거정보 수정</v-card-title>
                    <v-card-text>
                        <v-select v-model="collectStatus" :items="collectStatusItems" item-text="text" item-value="value" label="수거상태" placeholder=" "></v-select>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="collectDialog = false">취소</v-btn>
                        <v-btn color="primary" text @click="updateCollect">저장</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
export default {
    components: {
        VDateField
    },
    data() {
        return {
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showSearch: true,
            filter: {
                startDate: this.$route.query.startDate,
                endDate: this.$route.query.endDate,
                username: this.$route.query.username,
                phone: this.$route.query.phone,
                searchKey: this.$route.query.searchKey,
                searchValue: this.$route.query.searchValue,
                claimStatus: this.$route.query.claimStatus || ["return-request", "return-complete", "return-reject"],
                createDate: this.$route.query.createDate || [null, null]
            },
            searchKeys: [
                { text: "전체", value: null },
                { text: "수취인명", value: "receiver.name" },
                { text: "구매자명", value: "sender.name" },
                { text: "구매자연락처", value: "sender.phone" },
                { text: "구매자ID", value: "sender.username" },
                { text: "주문번호", value: "orderNo" },
                { text: "상품주문번호", value: "purchaseNo" },
            ],

            dashboard: {
                returnRequest: 0,
                collectProgress: 0,
                returnComplete: 0
            },

            ///////////////////////////////////////////////
            // 페이징
            ///////////////////////////////////////////////
            page: 1,
            pageCount: 0,
            limit: 20,

            ///////////////////////////////////////////////
            // 구매목록
            ///////////////////////////////////////////////
            selected: [],
            purchases: [],
            purchasesHeaders: [{
                text: '상품주문번호',
                align: 'center',
                width: 100,
                value: 'purchaseNo'
            },{
                text: '주문번호',
                align: 'center',
                width: 100,
                value: 'order.orderNo'
            },
            {
                text: '주문일자',
                align: 'center',
                width: 140,
                value: 'createDate'
            },
            {
                text: '주문상태',
                align: 'center',
                width: 140,
                value: 'orderStatusMessage'
            },
            {
                text: '클레임상태',
                align: 'center',
                width: 140,
                value: 'claimStatusMessage'
            },
            {
                text: '연락처',
                align: 'center',
                width: 128,
                value: 'order.sender.phone'
            },
            {
                text: '구매상품',
                align: 'center',
                width: 200,
                value: 'product.name'
            },
            {
                text: '옵션정보',
                align: 'center',
                width: 200,
                value: 'name'
            },
            {
                text: '구매수량',
                align: 'center',
                width: 100,
                value: 'quantity'
            },
            {
                text: '구매자',
                align: 'center',
                width: 120,
                value: 'order.sender'
            },
            {
                text: '수취인',
                align: 'center',
                width: 120,
                value: 'order.receiver'
            }],

            claimReply: null,
            claimReplyDialog: false,

            collectDialog: false,
            collectStatus: "collect-progress",
            collectStatusItems: [
                { text: "수거중", value: "collect-progress" },
                { text: "수거지연", value: "collect-pending" },
                { text: "수거완료", value: "collect-complete" },
            ]
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            try{
                await this.search(false);

            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async search(routable = true){
            try{
                if(routable){
                    this.$router.push({
                        query: Object.assign({}, this.filter, { page: this.page })
                    });
                }

                var { summary, purchases } = await api.console.shop.purchases.getPurchases({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit
                    },
                    params: this.filter
                });

                this.purchases = purchases;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);

                var { dashboard } = await api.console.shop.purchases.getDashboard({ manage: "return" });
                this.dashboard = dashboard;
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        // 수거완료
        async collectComplete(){
            try{
                if(!this.selected.length) throw new Error("수거완료를 하기위한 구매건을 선택해주세요");
                for(var i in this.selected){
                    await api.console.shop.purchases.putPurchase({
                        _id: this.selected[i]._id,
                        collectStatus: "collect-complete",
                    });
                }

                alert("수거완료 처리되었습니다");
                this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        // 반품완료
        async returnComplete(){
            try{
                if(!this.selected.length) throw new Error("반품완료 하기위한 구매건을 선택해주세요");
                for(var i in this.selected){
                    await api.console.shop.purchases.putPurchase({
                        _id: this.selected[i]._id,
                        claimStatus: "return-complete",
                        claimCompleteDate: Date.now()
                    });
                }

                alert("반품완료 처리되었습니다");
                this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        // 반품거부
        async returnReject(){
            try{
                if(!this.selected.length) throw new Error("반품거부 하기위한 구매건을 선택해주세요");
                for(var i in this.selected){
                    await api.console.shop.purchases.putPurchase({
                        _id: this.selected[i]._id,
                        claimStatus: "return-reject",
                        claimReply: this.claimReply,
                        claimCompleteDate: Date.now()
                    });
                }

                alert("반품거부 처리되었습니다");
                this.claimReplyDialog = false;
                this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        // 교환으로 변경
        async exchangeRequest(){
            try{
                if(!this.selected.length) throw new Error("교환변경을 하기위한 구매건을 선택해주세요");
                for(var i in this.selected){
                    await api.console.shop.purchases.putPurchase({
                        _id: this.selected[i]._id,
                        claimStatus: "exchange-request",
                        collectionStatus: null,
                        claimCompleteDate: null
                    });
                }

                alert("교환으로 변경되었습니다");
                this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        // 반품사유 수정
        // async updateExchange(){
        //     try{
        //         if(!this.selected.length) throw new Error("반품사유 변경을 위한 구매건을 선택해주세요");
        //         for(var i in this.selected){
        //             await api.console.shop.purchases.putPurchase({
        //                 _id: this.selected[i]._id,
        //                 claimReply: this.claimReply
        //             });
        //         }

        //         alert("반품사유가 변경되었습니다");
        //         this.search();
        //     }
        //     catch(error){
        //         console.error(error);
        //         alert(error.response ? error.response.data.message : error.message);
        //     }
        // },

        // 수거정보 수정
        async updateCollect(){
            try{
                if(!this.selected.length) throw new Error("수거정보수정을 하기위한 구매건을 선택해주세요");
                for(var i in this.selected){
                    await api.console.shop.purchases.putPurchase({
                        _id: this.selected[i]._id,
                        collectStatus: this.collectStatus,
                    });
                }

                alert("수거정보가 변경되었습니다");
                this.search();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
}
</script>
